<template>
  <v-data-table
    :value="selected"
    :headers="headers"
    :items="items"
    :items-per-page="10"
    :search="search"
    :loading="loading"
    :loading-text="'Chargement en cours...'"
    :hide-default-footer="!!$slots.footer"
    show-select
    item-key="_id"
    sort-by="number"
    multi-sort
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.createdAt`]="{ item }">
      <div>{{ moment(item.createdAt).format('L') }}</div>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        :to="`${item._id}`"
        append
        icon
      >
        <v-icon>visibility</v-icon>
      </v-btn>
    </template>

    <template v-if="$slots.footer" v-slot:footer="{ props, on }">
      <v-row
        align="center"
        no-gutters
        class="px-2"
        style="border-top: thin solid rgba(0, 0, 0, 0.12)"
      >
        <v-col cols="auto">
          <slot name="footer" />
        </v-col>
        <v-col>
          <v-data-footer v-bind="props" style="border: none" v-on="on" />
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>

export default {
  name: 'BatchList',
  components: {},
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Array,
      default: () => ([]),
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    resultWithStats: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers () {
      let baseHeaders = [
        {
          text: 'OF',
          align: 'center',
          value: 'number',
        },
        {
          text: 'Date de création',
          align: 'center',
          value: 'createdAt',
        },
        {
          text: 'Référence',
          align: 'center',
          value: 'partNumber.name',
        },
        {
          text: 'Type de référence',
          align: 'center',
          value: 'partType.name',
        },
        {
          text: 'Quantité initial',
          align: 'center',
          value: 'quantity',
        },

      ]

      if (this.resultWithStats) {
        baseHeaders = [
          ...baseHeaders,
          {
            text: 'Quantité actuelle',
            align: 'center',
            value: 'currentQuantity',
          },
          {
            text: 'Finis',
            align: 'center',
            value: 'finishCount',
          },
          {
            text: 'Rebuts',
            align: 'center',
            value: 'rejectedCount',
          },
          {
            text: 'Dérogations',
            align: 'center',
            value: 'exceptionCount',
          },
          {
            text: 'Retouches',
            align: 'center',
            value: 'retouchedCount',
          },
        ]
      }

      if (this.light) {
        return baseHeaders
      }

      return [
        ...baseHeaders,
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'center',
          width: '15%',
        },
      ]
    },
    items () {
      return this.value
    },
  },
}
</script>
